var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmail = function SvgEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.197 15.362a2.5 2.5 0 0 1-2.395 0L2 10.56v7.607a2.5 2.5 0 0 0 2.5 2.5h15a2.5 2.5 0 0 0 2.5-2.5V10.56l-8.803 4.802Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14a.832.832 0 0 1-.398-.102l-9.167-5A.833.833 0 0 1 2 8.167V6.5A2.5 2.5 0 0 1 4.5 4h15A2.5 2.5 0 0 1 22 6.5v1.667a.834.834 0 0 1-.435.731l-9.167 5A.832.832 0 0 1 12 14Z",
    fill: "currentColor"
  })));
};
export { SvgEmail as ReactComponent };
export default __webpack_public_path__ + "a5973f2df73655ddb897918b355088aa.svg";